import { EMPTY, Observable, of } from 'rxjs';
import { QtGroupBy } from '../models';
import { qGroupBy } from '../utils';
import {
  PIPE_ORDER,
  QtDataSourceContext,
  QtDataTransformAdapter,
} from './qt-control-adapter';

export class GroupByAdapter<T> implements QtDataTransformAdapter<T, null> {
  readonly key = 'groupByStatic';
  readonly persistent = false;
  readonly pipeOrder = PIPE_ORDER.GROUP_BY;
  readonly valueChanges$: Observable<null> = EMPTY;

  private _ctx: QtDataSourceContext | null = null;

  constructor(private groupBy: QtGroupBy<T>) {}

  setContext(ctx: QtDataSourceContext<any>): void {
    this._ctx = ctx;
  }

  get operator() {
    return qGroupBy<T>(
      this.groupBy,
      (this._ctx?.valueAccessorFn ?? ((): unknown => undefined)) as any,
      this._ctx?.columns$ ?? of([])
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  applyValue(_: null): void {}

  getValue(): null {
    return null;
  }
}
